import { createFileRoute } from "@tanstack/react-router";
import PrepareFromRecipe from "@/features/inventory/PrepareFromRecipe";

export const Route = createFileRoute("/inventory/prepare/recipe")({
  component: () => (
    <div className="max-w-4xl mx-auto p-4">
      <PrepareFromRecipe />
    </div>
  ),
});
